import type { QueryKey } from "@tanstack/react-query";

export const USER_KEY: QueryKey = ["user"];
export const AUTH_PROVIDERS_KEY: QueryKey = ["auth", "providers"];

export const LANGUAGES_KEY: QueryKey = ["translation", "languages"];

export const JOB_PROFILES_KEY: QueryKey = ["job-profiles"];
export const JOB_SEARCH_KEY: QueryKey = ["job-search"];
export const JOBS_KEY: QueryKey = ["jobs"];
export const SCRAPER_ACCOUNTS_KEY: QueryKey = ["scraper-accounts"];
export const APPLICATIONS_KEY: QueryKey = ["applications"];
export const APPLICATION_STATS_KEY: QueryKey = ["application-stats"];
export const AUTO_APPLY_CREDENTIALS_KEY: QueryKey = ["auto-apply", "credentials"];
export const AUTO_APPLY_SETTINGS_KEY: QueryKey = ["auto-apply", "settings"];
export const AUTO_APPLY_KILL_SWITCH_KEY: QueryKey = ["auto-apply", "kill-switch"];
export const NOTIFICATIONS_KEY: QueryKey = ["notifications"];
export const NOTIFICATION_UNREAD_COUNT_KEY: QueryKey = ["notifications", "unread-count"];

export const RESUME_KEY: QueryKey = ["resume"];
export const RESUMES_KEY: QueryKey = ["resumes"];
export const RESUME_PREVIEW_KEY: QueryKey = ["resume", "preview"];
export const getApplicationBaseResumeQueryKey = (resumeId?: string): QueryKey => [
  ...RESUME_KEY,
  "application-base",
  resumeId,
];
export const getNotificationsQueryKey = (params?: Record<string, unknown>): QueryKey => [
  ...NOTIFICATIONS_KEY,
  params ?? {},
];
